// QR impreso de recepción. El servidor guarda «norgym-recepcion:{gym}:{clave}»; el QR
// lleva un enlace (allgym.app/asistencia/{gym}#{clave}) para que la cámara del celular
// abra el portal en vez de mostrar texto. Los QR ya impresos con el formato antiguo
// siguen sirviendo desde el lector de la app.
const ANTIGUO = /^norgym-recepcion:([a-z0-9]{1,100}):([a-f0-9]{48})$/;
const ENLACE = /\/asistencia\/([a-z0-9]{1,100})\/?#([a-f0-9]{48})$/;
const PENDIENTE = 'allgym_recepcion_pendiente';
const VIGENCIA_PENDIENTE_MS = 15 * 60 * 1000;

/** Enlace que va en el QR impreso. */
export const enlaceRecepcion = (codigo, origen) => {
  const m = ANTIGUO.exec(String(codigo || ''));
  return m ? `${origen}/asistencia/${m[1]}#${m[2]}` : '';
};

/** Código que valida el servidor, desde lo que leyó la cámara (enlace o formato antiguo), o null. */
export const codigoRecepcion = (leido) => {
  const texto = String(leido || '').trim();
  if (ANTIGUO.test(texto)) return texto;
  const m = ENLACE.exec(texto);
  return m ? `norgym-recepcion:${m[1]}:${m[2]}` : null;
};

/** El enlace se abrió fuera de la app: se guarda hasta que el socio entra a su portal. */
export const guardarRecepcionPendiente = (codigo, ahora = Date.now()) => {
  try { sessionStorage.setItem(PENDIENTE, JSON.stringify({ codigo, ms: ahora })); } catch { /* sin almacenamiento: se escanea desde la app */ }
};
export const tomarRecepcionPendiente = (gymId, ahora = Date.now()) => {
  try {
    const p = JSON.parse(sessionStorage.getItem(PENDIENTE) || 'null');
    if (!p || ahora - p.ms > VIGENCIA_PENDIENTE_MS || ANTIGUO.exec(p.codigo || '')?.[1] !== gymId) return null;
    sessionStorage.removeItem(PENDIENTE);
    return p.codigo;
  } catch { return null; }
};
